import React from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router-dom";
import { getResults } from "../../shared/store/selectors/advisor";
import { toggleProduct } from "../../shared/store/actions/wishlist";
import ResultsWebUI from "../../components/Advisor/Results";

class Results extends React.Component {
  toggleWishlist = product => {
    this.props.toggleProduct(product.sku);
  };

  openVideo = product => {
    console.log("openVideo for product:", product);
    window.open(product.video, "_blank");
  };

  buyProduct = product => {
    console.log("buyProduct for product:", product);
    window.open(product.url, "_blank");
  };

  render() {
    return (
      <ResultsWebUI
        advisor={this.props.advisor}
        results={this.props.results}
        onToggleWishlist={this.toggleWishlist}
        onOpenVideo={this.openVideo}
        onBuyProduct={this.buyProduct}
      />
    );
  }
}

const mapStateToProps = state => ({
  results: getResults(state),
  advisor: state.advisor
});

export default connect(
  mapStateToProps,
  { toggleProduct }
)(withNamespaces(["results", "common"], { wait: true })(withRouter(Results)));
